/* biobio-countdown.js
   Contador regressivo de campanha (ex: BioBio Day), Web Component vanilla,
   sem dependencias. Atualiza a cada segundo e some/avisa quando expira.

   Uso:
     <biobio-countdown end="2026-06-06T23:59:00-03:00" data-prefix="Termina em">
       <span class="biobio-countdown__fallback">Oferta por tempo limitado</span>
     </biobio-countdown>

   Atributos opcionais:
     start="..."            a faixa ja aparece, mas o contador so a partir deste instante
                            (teaser; esconde o componente ate la, pelo relogio do cliente).
     daily                  modo diario (10.10): o alvo e a proxima meia-noite no fuso
                            -03:00 ou o `end`, o que vier antes; ao virar o dia recomeca
                            sozinho, sem recarregar. Continua sem mostrar dias.
     data-prorrogado="..."  rotulo do selo que aparece, no modo diario, quando o dia
                            civil de agora e posterior ao dia de `start` (ou de
                            data-inicio-ref). Vazio = sem selo.
     data-inicio-ref="..."  referencia de dia para o selo SEM esconder o componente
                            antes dela (a faixa do topo ja faz o gate de inicio por conta).

   O conteudo interno (fallback) fica visivel se o JS nao rodar ou a data for
   invalida. O timer visual e aria-hidden; um rotulo .visually-hidden descreve
   o tempo restante para leitores de tela sem spammar a cada segundo. */
(function () {
  if (window.customElements && customElements.get('biobio-countdown')) return;

  /* Sem "dias": a campanha ativa o contador faltando poucas horas, entao "dias"
     ficaria 00 e poluiria. "horas" acumula os dias (ex: 26 horas), caso ligado
     com mais de 24h restantes. No modo diario nunca passa de 23. */
  var UNITS = [
    { key: 'h', label: 'horas' },
    { key: 'm', label: 'min' },
    { key: 's', label: 'seg' }
  ];
  /* Fuso fixo da loja (-03:00, BR sem horario de verao): o dia civil e o de
     Brasilia para qualquer visitante, igual ao resto do calendario. */
  var TZ_MIN = -180;
  var DIA_MS = 86400000;

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* Inteiro que cresce a cada meia-noite de Brasilia. */
  function diaLocal(ms) { return Math.floor((ms + TZ_MIN * 60000) / DIA_MS); }
  /* Instante (ms UTC) da proxima meia-noite de Brasilia depois de `ms`. */
  function proximaMeiaNoite(ms) { return (diaLocal(ms) + 1) * DIA_MS - TZ_MIN * 60000; }

  class BioBioCountdown extends HTMLElement {
    connectedCallback() {
      var raw = this.getAttribute('end');
      this.end = raw ? new Date(raw) : null;
      if (!this.end || isNaN(this.end.getTime())) return; // mantem o fallback

      this._daily = this.hasAttribute('daily');
      this._tagLabel = this.getAttribute('data-prorrogado') || '';
      this._start = null;
      var startRaw = this.getAttribute('start');
      if (startRaw) {
        var start = new Date(startRaw);
        if (!isNaN(start.getTime())) this._start = start;
      }
      this._inicioRef = this._start;
      var refRaw = this.getAttribute('data-inicio-ref');
      if (!this._inicioRef && refRaw) {
        var ref = new Date(refRaw);
        if (!isNaN(ref.getTime())) this._inicioRef = ref;
      }

      /* `start`: quem decide e o relogio do CLIENTE, nao o do servidor: a pagina
         de colecao e cacheada, entao um gate so em Liquid poderia servir HTML
         velho. O Liquid tambem esconde, mas so pra nao piscar antes do JS. */
      if (this._start && Date.now() < this._start.getTime()) {
        this.style.display = 'none';
        var faltam = this._start.getTime() - Date.now();
        /* setTimeout estoura acima de ~24,8 dias; acima disso nem agenda,
           porque quem deixa a aba aberta tanto tempo recarrega antes. */
        if (faltam < 2147483647) {
          this._reveal = setTimeout(function () {
            this.style.removeProperty('display');
            this.connectedCallback();
          }.bind(this), faltam);
        }
        return;
      }
      this.style.removeProperty('display');

      this._prefix = this.getAttribute('data-prefix') || '';
      this._build();
      this._update();
      this._iv = setInterval(this._update.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this._iv) { clearInterval(this._iv); this._iv = null; }
      if (this._reveal) { clearTimeout(this._reveal); this._reveal = null; }
    }

    /* Fim do ciclo corrente: no modo diario, a meia-noite seguinte ou o fim da
       campanha, o que vier antes; fora dele, o fim. */
    _fimCiclo(agora) {
      var fim = this.end.getTime();
      if (!this._daily) return fim;
      var mn = proximaMeiaNoite(agora);
      return mn < fim ? mn : fim;
    }

    _prorrogado(agora) {
      if (!this._daily || !this._inicioRef) return false;
      return diaLocal(agora) > diaLocal(this._inicioRef.getTime());
    }

    _build() {
      this.textContent = '';
      var inner = document.createElement('span');
      inner.className = 'biobio-countdown__inner';
      inner.setAttribute('aria-hidden', 'true');

      this._tag = null;
      if (this._daily && this._tagLabel) {
        var tag = document.createElement('span');
        tag.className = 'biobio-countdown__tag';
        tag.textContent = this._tagLabel;
        tag.hidden = true;
        inner.appendChild(tag);
        this._tag = tag;
      }

      if (this._prefix) {
        var p = document.createElement('span');
        p.className = 'biobio-countdown__prefix';
        p.textContent = this._prefix;
        inner.appendChild(p);
      }

      this._segs = {};
      var self = this;
      UNITS.forEach(function (u) {
        var seg = document.createElement('span');
        seg.className = 'biobio-countdown__seg';
        var num = document.createElement('span');
        num.className = 'biobio-countdown__num';
        num.textContent = '00';
        var lbl = document.createElement('span');
        lbl.className = 'biobio-countdown__lbl';
        lbl.textContent = u.label;
        seg.appendChild(num);
        seg.appendChild(lbl);
        inner.appendChild(seg);
        self._segs[u.key] = { seg: seg, num: num };
      });

      this.appendChild(inner);

      this._sr = document.createElement('span');
      this._sr.className = 'biobio-countdown__sr visually-hidden';
      this.appendChild(this._sr);
    }

    _update() {
      var agora = Date.now();
      if (agora >= this.end.getTime()) {
        if (this._iv) { clearInterval(this._iv); this._iv = null; }
        this.textContent = '';
        var done = document.createElement('span');
        done.className = 'biobio-countdown__done';
        done.textContent = 'Oferta encerrada';
        this.appendChild(done);
        return;
      }
      /* Modo diario: ao passar da meia-noite o alvo vira a proxima meia-noite,
         entao o contador recomeca sozinho e o selo entra no mesmo tick. */
      var diff = Math.floor((this._fimCiclo(agora) - agora) / 1000);
      if (diff < 0) diff = 0;
      if (this._tag) this._tag.hidden = !this._prorrogado(agora);
      var h = Math.floor(diff / 3600); diff -= h * 3600;
      var m = Math.floor(diff / 60); var s = diff - m * 60;
      var vals = { h: h, m: m, s: s };
      var self = this;
      UNITS.forEach(function (u) {
        self._segs[u.key].num.textContent = pad(vals[u.key]);
      });
      var sr = 'Oferta termina em ' + h + ' horas e ' + m + ' minutos';
      if (this._tag && !this._tag.hidden) sr = this._tagLabel + '. ' + sr;
      this._sr.textContent = sr;
    }
  }

  customElements.define('biobio-countdown', BioBioCountdown);
})();
